import { unstable_cache } from "next/cache";

import { logger } from "@/core/logging";

import { resolveGrowthBookClientKey } from "@/core/featureFlags/growthbook.config";

const CACHE_KEY = "growthbook-features";

/**
 * Fetches feature flags from GrowthBook CDN
 * Uses Next.js caching to avoid excessive API calls
 *
 * @returns Feature definitions from GrowthBook or null on error
 */
export async function fetchFeatures() {
  const clientKey = resolveGrowthBookClientKey();

  if (!clientKey) {
    logger.warn("growthbook_client_key_missing");
    return null;
  }

  try {
    const response = await fetch(`https://cdn.growthbook.io/api/features/${clientKey}`, {
      next: {
        revalidate: 60,
      },
    });

    if (!response.ok) {
      logger.error("growthbook_features_fetch_failed", {
        status: response.status,
      });
      return null;
    }

    const data = await response.json();
    return data?.features || null;
  } catch (error) {
    logger.error("growthbook_features_fetch_error", undefined, error as Error);
    return null;
  }
}

/**
 * Cached version of fetchFeatures
 * Caches for 60 seconds to reduce server load
 */
export const getCachedFeatures = unstable_cache(() => fetchFeatures(), [CACHE_KEY], {
  revalidate: 60,
  tags: [CACHE_KEY],
});
